import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Paper, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Status } from '../../../common/constants';
import Colours from '../../../styles/colours';
import PostAction from '../../../actions/post';
import postStyle from '../../../styles/post';
import MText from '../../../components/Common/MText';

const Launch = (props) => {
  const [isPending, setIsPending] = useState(false);
  const [isDraft, setIsDraft] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    setIsLive(props.post.status === Status.Live);
    setIsDraft(props.post.status === Status.Draft);
    setIsPaused(props.post.status === Status.Paused);
    setIsPending(props.post.status === Status.Pending);
  }, [props.post]);

  return (
    <Paper className="pb-4 px-5" style={postStyle.paper}>
      <MText className="mt-3" style={postStyle.textHeader} text="Select status:"/>

      <div className="px-3 mt-4">
        {[Status.Draft, Status.Pending].includes(props.post.currentPostStatus) && (
          <div className="mb-1 mt-3">
            <FormControl component="fieldset">
              <RadioGroup aria-label="Save as Draft" name="customized-radios">
                <FormControlLabel
                  control={<Radio checked={isDraft} color="primary" />}
                  label={(
                    <div className="ml-2">
                      <MText bold={isDraft} size={13}>
                        Save as Draft
                      </MText>
                      <MText colour={Colours.Gray} size={11}>
                        Continue editing later
                      </MText>
                    </div>
                  )}
                  onClick={() => {
                    props.dispatchPostUpdate({ status: Status.Draft });
                  }}
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}

        {[Status.Pending].includes(props.post.currentPostStatus) && (
          <>
            <hr className="my-4" />
            <div className="mt-4 mb-4 pt-2">
              <FormControl component="fieldset">
                <RadioGroup aria-label="Pending" name="customized-radios">
                  <FormControlLabel
                    control={<Radio checked={isPending} color="primary" />}
                    label={(
                      <div className="ml-2">
                        <MText bold={isPending} size={13}>
                          Continue as Pending
                        </MText>
                        <MText colour={Colours.Gray} size={11}>
                          Post wont be live and searchable in the app until the Page's status is approved.
                        </MText>
                      </div>
                    )}
                    onClick={() => {
                      props.dispatchPostUpdate({ status: Status.Pending  });
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </>
        )}

        {[Status.Draft, Status.Live, Status.Paused].includes(props.post.currentPostStatus) && (
          <>
            <hr className="my-4" />
            <div className="mt-4 mb-4 pt-2">
              <FormControl component="fieldset">
                <RadioGroup aria-label="Launch Now" name="customized-radios">
                  <FormControlLabel
                    control={<Radio checked={isLive} color="primary" />}
                    label={(
                      <div className="ml-2">
                        <MText bold={isLive} size={13} >
                          {
                            props.post.currentPostStatus === Status.Draft
                              ? `Launch to Live`
                              : (
                                props.post.currentPostStatus === Status.Live
                                  ? 'Continue as Live'
                                  : 'Update back to Live'
                              )
                          }
                        </MText>
                        <MText colour={Colours.Gray} size={11}>
                          Set/Update the post as Live and searchable in the app
                        </MText>
                      </div>
                    )}
                    onClick={() => {
                      props.dispatchPostUpdate({ status: Status.Live  });
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </>
        )}

        {[Status.Live, Status.Paused].includes(props.post.currentPostStatus) && (
          <>
            <hr className="my-4" />
            <div className="mt-4 mb-4 pt-2">
              <FormControl component="fieldset">
                <RadioGroup aria-label="Pause post" name="customized-radios">
                  <FormControlLabel
                    control={<Radio checked={isPaused} color="primary" />}
                    label={(
                      <div className="ml-2">
                        <MText bold={isPaused} size={13}>
                          {
                            props.post.currentPostStatus === Status.Paused
                              ? 'Continue as Paused'
                              : 'Update Post as Paused'
                          }
                        </MText>
                        <MText colour={Colours.Gray} size={11}>
                          Temporary take-down the post from the app. Post won't be live and searchable in the app until you update the post back to Live.
                        </MText>
                      </div>
                    )}
                    onClick={() => {
                      props.dispatchPostUpdate({ status: Status.Paused });
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </>
        )}
      </div>
    </Paper>
  );
};

Launch.propTypes = {
  dispatchPostUpdate: PropTypes.func.isRequired,

  post: PropTypes.shape({
    status:            PropTypes.oneOf([Status.Draft, Status.Pending, Status.Live, Status.Rejected, Status.Paused]),
    currentPostStatus: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  post: state.post.selected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchPostUpdate: (post) => PostAction.postDataUpdate(dispatch, post),
});

export default connect(mapStateToProps, mapDispatchToProps)(Launch);
